import { IdentifyTrait } from 'shared/tracking/contracts';
import { getUserTaxonomy } from '../trackPage';

export const identifyUser = async (window?: Partial<Window>) => {
    if (typeof window === 'undefined' || !window.analytics) {
        return;
    }

    const { user_uuid } = await getUserTaxonomy();
    const identifyTrait: IdentifyTrait = {
        user_uuid
    };

    if (user_uuid) {
        window.analytics.identify(user_uuid, identifyTrait);
    }
};
